import {
    FETCH_LANG_DASHBOARD_SUCCESS,
} from '../constants/ActionTypes';

const initialState = {
    langDashboard: {
        noKpi: "ไม่มีข้อมูล KPI",
        noProject: "ไม่มีข้อมูลโครงการ",
        activeCustomer: "Active Customer",
        active: "Active",
        customer: "ลูกค้า",
        clientVisit: "เข้าเยี่ยมลูกค้า",
        visit: "เข้าเยี่ยม",
        salesStatistic: "Sales Statistic",
        mtdAmt: "ยอดรายเดือน",
        qtdAmt: "ยอดรายไตรมาส",
        ytdAmt: "ยอดสะสมตั้งแต่ต้นปี",
        salesOrderAmt: "ยอดสั่งซื้อสินค้า",
        backOrderAmt: "ยอดค้างส่งสินค้า",
        cancelOrderAmt: "ยอดคืนสินค้า",
        chartMtdAmt: "กราฟยอดขายรายเดือน",
        target: "เป้า",
        currentMonth: "เดือนนี้",
        currentMonthLastYear: "เดือนนี้ปีก่อน",
        salesNote: "ยอด Sales Note",
        invoiceAmt: "Invoice", //ใบแจ้งหนี้
        rejectAmt: "C/N", //ยกเลิก
        returnAmt: "Back Order", //ส่งคืน
        customerGroup: "กลุ่มลูกค้า",
        productGroup: "กลุ่มสินค้า",
        salesTeam: "ทีมขาย",
        chartInvoiceCreditNote: "กราฟเทียบใบแจ้งหนี้กับใบลดหนี้",
        creditNote: "C/N",
        invoice: "Invoice",
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LANG_DASHBOARD_SUCCESS:
            return {
                ...state,
                langDashboard: {
                    noKpi: action.payload.noKpi ? action.payload.noKpi : initialState.langDashboard.noKpi,
                    activeCustomer: action.payload.activeCustomer ? action.payload.activeCustomer : initialState.langDashboard.activeCustomer,
                    active: action.payload.active ? action.payload.active : initialState.langDashboard.active,
                    customer: action.payload.customer ? action.payload.customer : initialState.langDashboard.customer,
                    clientVisit: action.payload.clientVisit ? action.payload.clientVisit : initialState.langDashboard.clientVisit,
                    visit: action.payload.visit ? action.payload.visit : initialState.langDashboard.visit,
                    salesStatistic: action.payload.salesStatistic ? action.payload.salesStatistic : initialState.langDashboard.salesStatistic,
                    mtdAmt: action.payload.mtdAmt ? action.payload.mtdAmt : initialState.langDashboard.mtdAmt,
                    qtdAmt: action.payload.qtdAmt ? action.payload.qtdAmt : initialState.langDashboard.qtdAmt,
                    ytdAmt: action.payload.ytdAmt ? action.payload.ytdAmt : initialState.langDashboard.ytdAmt,
                    salesOrderAmt: action.payload.salesOrderAmt ? action.payload.salesOrderAmt : initialState.langDashboard.salesOrderAmt,
                    backOrderAmt: action.payload.backOrderAmt ? action.payload.backOrderAmt : initialState.langDashboard.backOrderAmt,
                    cancelOrderAmt: action.payload.cancelOrderAmt ? action.payload.cancelOrderAmt : initialState.langDashboard.cancelOrderAmt,
                    chartMtdAmt: action.payload.chartMtdAmt ? action.payload.chartMtdAmt : initialState.langDashboard.chartMtdAmt,
                    target: action.payload.target ? action.payload.target : initialState.langDashboard.target,
                    currentMonth: action.payload.currentMonth ? action.payload.currentMonth : initialState.langDashboard.currentMonth,
                    currentMonthLastYear: action.payload.currentMonthLastYear ? action.payload.currentMonthLastYear : initialState.langDashboard.currentMonthLastYear,
                    salesNote: action.payload.salesNote ? action.payload.salesNote : initialState.langDashboard.salesNote,
                    invoiceAmt: action.payload.invoiceAmt ? action.payload.invoiceAmt : initialState.langDashboard.invoiceAmt,
                    rejectAmt: action.payload.rejectAmt ? action.payload.rejectAmt : initialState.langDashboard.rejectAmt,
                    returnAmt: action.payload.returnAmt ? action.payload.returnAmt : initialState.langDashboard.returnAmt,
                    customerGroup: action.payload.customerGroup ? action.payload.customerGroup : initialState.langDashboard.customerGroup,
                    productGroup: action.payload.productGroup ? action.payload.productGroup : initialState.langDashboard.productGroup,
                    salesTeam: action.payload.salesTeam ? action.payload.salesTeam : initialState.langDashboard.salesTeam,
                    chartInvoiceCreditNote: action.payload.chartInvoiceCreditNote ? action.payload.chartInvoiceCreditNote : initialState.langDashboard.chartInvoiceCreditNote,
                    creditNote: action.payload.creditNote ? action.payload.creditNote : initialState.langDashboard.creditNote,
                    invoice: action.payload.invoice ? action.payload.invoice : initialState.langDashboard.invoice,
                }
            }
        default:
            return state;
    }
}